import React, { useState } from "react";

import test_ipynb from "../../static/nb_test.json"
// import JupyterNotebookComp from "./JupyterNotebookComp";
import RunNotebook from "./RunNotebook";
const JupyterNotebook = () => {
    const [rawIpynb, setRawIpynb] = useState(test_ipynb);
    const [counter, setCounter] = useState(0);

    const reRenderNotebook = () => {
        setCounter((counter + 1) % 2)
    }
    // Save ipynb
    const downloadNotebook = () => {
        const jsonData = JSON.stringify(rawIpynb);
        const blob = new Blob([jsonData], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'notebook.ipynb';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const handleOnUploadFile = (e) => {
        if (e.target.files[0]) {
            const reader = new FileReader();
            reader.readAsText(e.target.files[0], "UTF-8");
            reader.onload = (e) => {
                setRawIpynb(JSON.parse(e.target.result));
            };
            reader.onerror = (e) => {
                console.log('reader error!', e)
            };
        }
        e.target.value = "";
    }
    return (
        <div style={{ height: "100vh" }}>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    // backgroundColor: "#918f8f",
                    height: "30px"
                }}
            >
                <input
                    name="rawIpynb"
                    type="file"
                    onChange={(e) => { handleOnUploadFile(e) }}
                />
                {/* Download Ipynb */}
                <div>
                    <button onClick={downloadNotebook}>Download IPYNB</button>
                </div>
            </div>
            {rawIpynb && <RunNotebook rawIpynb1={rawIpynb} setRawIpynb1={setRawIpynb} reRenderNotebook={reRenderNotebook} />}
        </div>
    )

}

export default JupyterNotebook;